import { IPages, ISocialMedia } from '../types/footer-menu.type';

/** Platform column: How it Works, Marketplace, Installers */
export const footerPlatformPages: IPages[] = [
  { id: 0, name: 'footer.howItWorks', link: '/help' },
  { id: 1, name: 'footer.marketplace', link: '/products' },
  { id: 2, name: 'footer.installers', link: '/solutions' },
];

/** Company column: About Us, Team, Contact */
export const footerCompanyPages: IPages[] = [
  { id: 0, name: 'footer.aboutUs', link: '/about' },
  { id: 1, name: 'footer.team', link: '/team' },
  { id: 2, name: 'footer.contact', link: '/contact' },
];

/** legal column — core policies (left sub-column) */
export const footerLegalColumnPrimary: IPages[] = [
  { id: 0, name: 'footer.legal.termsOfService', link: '/legal/terms-of-service' },
  { id: 1, name: 'footer.legal.privacyPolicy', link: '/legal/privacy-policy' },
  { id: 2, name: 'footer.legal.cookiePolicy', link: '/legal/cookie-policy' },
  { id: 3, name: 'footer.legal.acceptableUse', link: '/legal/acceptable-use-policy' },
];

/** legal column — platform-specific policies (right sub-column) */
export const footerLegalColumnSecondary: IPages[] = [
  { id: 0, name: 'footer.legal.platformDisclaimer', link: '/legal/platform-disclaimer' },
  { id: 1, name: 'footer.legal.paymentTerms', link: '/legal/payment-terms' },
  { id: 2, name: 'footer.legal.dataProcessing', link: '/legal/data-processing-statement' },
  { id: 3, name: 'footer.legal.goldenThread', link: '/legal/golden-thread-disclaimer' },
];

/** @deprecated use footerLegalColumnPrimary + footerLegalColumnSecondary */
export const footerLegalColumn: IPages[] = [
  ...footerLegalColumnPrimary,
  ...footerLegalColumnSecondary,
];

/** @deprecated bottom bar now shows social links instead */
export const footerLegalPages: IPages[] = footerLegalColumnPrimary;

/** @deprecated use footerPlatformPages */
export const footerPages1: IPages[] = footerPlatformPages;

/** @deprecated use footerCompanyPages */
export const footerPages2: IPages[] = footerCompanyPages;

export const footerSocialMedias: ISocialMedia[] = [
  {
    id: 0,
    title: 'LinkedIn',
    icon: 'assets/icons/footer-icons/linkedin-gray.svg',
    iconHover: 'assets/icons/footer-icons/linkedin-primary.svg',
    link: 'https://www.linkedin.com/company/wejoiner',
  },
  {
    id: 1,
    title: 'X',
    icon: 'assets/icons/socials/x-icon.svg',
    iconHover: 'assets/icons/socials/x-icon.svg',
    link: 'https://x.com/wejoiner',
  },
];
